<template>
  <div class="right_box_main">
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div :body-style="{ padding: '16px' }" class="card-r">
          <!-- <div class="showleft">显示</div> -->
          <el-card class="card-0">
            <div class="topbarnav">
              <img src="../../../assets/images/icons/13.png" alt />
              <div>概览</div>
            </div>
            <div class="onebuttom">
              <div class="child-item">
                <div>{{showDatas.wait}}</div>
								<div>今日申办</div>
              </div>
              <div class="child-item">
                <div>{{showDatas.undo}}</div>
								<div>未处理</div>
              </div>
              <div class="child-item">
                <div>{{showDatas.error}}</div>
								<div>办理异常</div>
              </div>
              <div class="child-item">
                <div>{{showDatas.end}}</div>
								<div>已处理</div>
              </div>
            </div>
          </el-card>
          <el-card class="card-2">
            <div class="topbarnav">
              <img src="../../../assets/images/icons/14.png" alt />
              <div>按组织统计</div>
            </div>
            <div class="onebuttom">
              <div id="chart_1_1"></div>
            </div>
          </el-card>
        </div>
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="申请人:" style="margin:0 30 0 0;">
                  <el-input v-model="searchlist.name" placeholder="请输入姓名" style="width:120px;"></el-input>
                </el-form-item>
                <el-form-item label="申办编号:" style="margin:0 30 0 0;">
                  <el-input v-model="searchlist.number" placeholder="请输入申办号" style="width:120px;"></el-input>
                </el-form-item>
                <el-form-item label="申请人手机:" style="margin:0 30 0 0;">
                  <el-input v-model="searchlist.phone" placeholder="请输入手机号码" style="width:120px;"></el-input>
                </el-form-item>
                <el-form-item label="处理状态:" style="margin:0 30 0 0;">
                  <el-select v-model="searchlist.doStatus " placeholder="--请选择--" style="width:120px" >
                    <el-option v-for="item in searchStatus" 
                      :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="办理状态:" style="margin:0 30 0 0;">
                  <el-select v-model="searchlist.retStatus " placeholder="--请选择--" style="width:120px" >
                    <el-option v-for="item in searchResults" 
                      :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button type="danger" size="mini"  @click="createExcel">导出Excel</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" current-row-key highlight-current-row >
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <!-- <el-table-column type="index" align="center" label="序号" width="50"></el-table-column> -->
                <el-table-column align="center" prop="applyNid" label="申办证号" width="140"></el-table-column>
                <el-table-column align="center" prop="applyName" label="申办人" width="110"></el-table-column>
                <el-table-column align="center" prop="applyPhone" label="手机号" width="140"></el-table-column>
                <el-table-column align="center" prop="certificatesName" label="办理证件名称" width="240"></el-table-column>
                <el-table-column align="center" prop="certificatesType" label="办理证件类别" width="160"></el-table-column>
                <el-table-column align="center" prop="createDate" label="申办日期" width="180"></el-table-column>
                <el-table-column align="center" prop="delay" label="是否延期" width="100">
                  <template scope="scope">
                    <span class="tab" :class="{ active_tab2: scope.row.delay == '1',active_tab1:scope.row.delay=='0'}">
                      {{ scope.row.delay == '1'?'已延迟':'未延迟' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="handleState" label="处理状态" width="100">
                  <template scope="scope">
                    <span class="tab"
                      :class="{ active_tab2: scope.row.handleState == '1',active_tab1:scope.row.handleState=='0',active_tab:scope.row.handleState=='2'}"
                    >{{ scope.row.handleState == '1'?'接收':(scope.row.handleState == '2'?'不接收':'未处理') }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="handlingStatus" label="办理状态" width="100">
                  <template scope="scope">
                    <span class="tab"
                      :class="{ active_tab2: scope.row.handlingStatus == '1',active_tab1:scope.row.handlingStatus=='0',active_tab:scope.row.handlingStatus=='2',active_tab3:scope.row.handlingStatus=='3'}"
                    >{{ scope.row.handlingStatus == '0'?'办理中':(scope.row.handlingStatus == '1'?'待领证':(scope.row.handlingStatus == '2'?'办理异常':'已完成')) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.handleState!='1'" class="item" effect="light" content="处理" placement="top-start">
                      <button  class="iconfont icon-queding tabBtn" @click="showDialogForm(scope.row.id,'do')"></button>
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.handlingStatus!='1'" class="item" effect="light" content="办理" placement="top-start" style="fontWeight:bold" >
                      <button  class="iconfont icon-xuanxiangkuangqueding tabBtn" @click="showDialogForm(scope.row.id,'result')"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button class="iconfont icon-chakan tabBtn" @click="showDialogForm(scope.row.id,'detail')"></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageConfig.pageNo" :page-sizes="[10, 20, 30, 50]"
                :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="pageConfig.total">
              </el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 处理/办理/查看 -->
    <el-dialog :title="dialogTitle" :visible.sync="showadd" width="900px" :before-close="clearadddata">
      <el-form ref="addform" :model="addform" label-width="110px" size="mini">
        <el-form-item label="证件类型:">
          <el-select v-model="addform.certificatesType" disabled placeholder="--请选择--" style="width:50%" >
            <el-option v-for="item in Types" 
              :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件名称：">
          <el-input v-model="addform.certificatesName" disabled placeholder="请输入模板名称" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="申办证号：">
          <el-input v-model="addform.applyNid" disabled placeholder="请输入申办证号" style="width: 50%;"></el-input>
        </el-form-item>
        <!-- 基本信息 -->
        <div v-if="addform.template.basicOptions" class="tempItem" style="margin: 20px 0px;height:96px">
          <div class="leftstyle">
            <div>基本信息</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="addform.template.basicOptions.indexOf('applyName')!=-1" label="申请人姓名:">
                  <el-input v-model="addform.applyName" size="mini" disabled placeholder="请输姓名" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="addform.template.basicOptions.indexOf('applyPhone')!=-1" label="申请人手机号:">
                  <el-input v-model="addform.applyPhone" size="mini" disabled placeholder="请输入手机号" style="width:250px"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 男方申请资料 -->
        <div v-if="addform.template.fixedOption" class="tempItem" style="margin: 20px 0px;height:150px">
          <div class="leftstyle">
            <div>男方申请资料</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="addform.template.fixedOption.indexOf('manName')!=-1" label="姓名:">
                  <el-input v-model="addform.manName" size="mini" disabled placeholder="请输入姓名" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item v-if="addform.template.fixedOption.indexOf('manTypeNo')!=-1" label="证件号码:">
                  <el-input v-model="addform.manCertificateNumber" size="mini" disabled placeholder="请输入证件号码" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="addform.template.fixedOption.indexOf('manType')!=-1" label="证件类型:">
                  <el-select v-model="addform.manCertificate" disabled placeholder="--请选择--" size="mini" style="width:250px">
                    <el-option v-for="item in IDTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 女方申请资料 -->
        <div v-if="addform.template.fixedOption" class="tempItem" style="margin: 20px 0px;height:150px">
          <div class="leftstyle">
            <div>女方申请资料</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:30px  0 0 0">
              <div class="rdxxflex1">
                <el-form-item v-if="addform.template.fixedOption.indexOf('womanName')!=-1" label="姓名:">
                  <el-input v-model="addform.womanName" size="mini" disabled placeholder="请输入姓名" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item v-if="addform.template.fixedOption.indexOf('womanTypeNo')!=-1" label="证件号码:">
                  <el-input v-model="addform.womanCertificateNumber" size="mini" disabled placeholder="请输入证件号码" style="width:250px"></el-input>
                </el-form-item>
              </div>
              <div class="rdxxflex2">
                <el-form-item v-if="addform.template.fixedOption.indexOf('womanType')!=-1" label="证件类型:">
                  <el-select v-model="addform.womanCertificate" disabled placeholder="--请选择--" size="mini" style="width:250px">
                    <el-option v-for="item in IDTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 男方身份证 -->
        <div v-if="addform.template.fixedOption.indexOf('manCardImg')!=-1" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>男方</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div class="rdxxflex1">
                <div class="imgDiv">
                  <img v-if="addform.manCardImg_1" :src="addform.manCardImg_1" alt />
                  <img v-else src="../../../assets/images/oneStopProcessing/2.jpg" alt />
                </div>
              </div>
              <div class="rdxxflex2">
                <div class="imgDiv">
                  <img v-if="addform.manCardImg_2" :src="addform.manCardImg_2" alt />
                  <img v-else src="../../../assets/images/oneStopProcessing/3.jpg" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 女方身份证资料 -->
        <div v-if="addform.template.fixedOption.indexOf('womanCardImg')!=-1" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>女方</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div class="rdxxflex1">
                <div class="imgDiv">
                  <img v-if="addform.womanCardImg_1" :src="addform.womanCardImg_1" alt />
                  <img v-else src="../../../assets/images/oneStopProcessing/2.jpg" alt />
                </div>
              </div>
              <div class="rdxxflex2">
                <div class="imgDiv">
                  <img v-if="addform.womanCardImg_2" :src="addform.womanCardImg_2" alt />
                  <img v-else src="../../../assets/images/oneStopProcessing/3.jpg" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 材料上传 -->
        <div v-if="addform.template.enclosure" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>其它</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div v-for="item in enclosure1" :key="item.index" :class="'rdxxflex'+item.index">
                <div class="imgDiv">
                  <img :src="item.img" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="enclosure2.length>0" class="tempItem" style="margin: 20px 0px;height:210px">
          <div class="leftstyle">
            <div>材料上传<br><br>|<br><br>其它</div>
          </div>
          <div class="rdxxright">
            <div class="rdxxflextop" style="height:80%; margin:20px  0 0 0">
              <div v-for="item in enclosure2" :key="item.index" :class="'rdxxflex'+item.index">
                <div class="imgDiv">
                  <img :src="item.img" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-form-item v-if="showReceiveStatus" label="处理状态：" prop="handleState">
          <el-radio-group :disabled="receiveDisable" v-model="addform.handleState" @change="receiveChange">
            <el-radio label="0">接收</el-radio>
            <el-radio label="1">不接收</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showReceiveStatus && showReceiveStatusYes" label="所需工作日：">
          <el-input :disabled="receiveDisable" v-model="addform.requiredTime" placeholder="请输入天数" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item v-if="showReceiveStatus && showReceiveStatusYes" label="备注: ">
          <el-input :disabled="receiveDisable" type="textarea" style="width:50%" :rows="3" 
            placeholder="请输入内容" v-model="addform.processingRemarks"></el-input>
        </el-form-item>
        <el-form-item v-if="showReceiveStatus && showReceiveStatusNo" label="原因：" prop="reason">
          <el-radio-group :disabled="receiveDisable" v-model="addform.reason">
            <el-radio label="0">资料不全</el-radio>
            <el-radio label="1">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showReceiveStatus && showReceiveStatusNo" label="原因描述: ">
          <el-input :disabled="receiveDisable" type="textarea" style="width:50%" :rows="3" 
            placeholder="请输入内容" v-model="addform.reasonExplain"></el-input>
        </el-form-item>
        
        <!-- 办理状态 -->
        <el-form-item v-if="showStatus" label="办理状态" prop="handlingStatus">
          <el-radio-group :disabled="statusDisable" v-model="addform.handlingStatus">
            <el-radio label="0">处理中</el-radio>
            <el-radio label="1">办理异常</el-radio>
            <el-radio label="2">待领证</el-radio>
            <el-radio label="3">办理完成</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button v-if="showSaveBtn" type="primary" size="small" style="margin: 0 30px" @click="saveadddata">保存</el-button>
        <el-button type="info" size="small" @click="clearadddata">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { log } from 'util';
import echarts_msg from '../../../utils/echarts.js'
import request from "../../../utils/request.js"
let token = JSON.parse(window.localStorage.getItem("user"));

export default {
  data() {
    return {
      showDatas: {wait: 0, undo: 0, error: 0, end: 0},
      flag: 'add',
      dialogTitle: '新增',
      // 新增弹出层
      showReceiveStatus: false,
      showReceiveStatusYes: false,
      showReceiveStatusNo: false,
      receiveDisable: true,
      showStatus: false,
      statusDisable: true,
      showadd: false,
      showSaveBtn: false,
      addform: {
        template: {
          basicOptions: '',
          fixedOption: '',
          enclosure: ''
        }
      },
      enclosure1: [],
      enclosure2: [],
      IDTypes: [],
      searchlist:{},
      searchStatus: [],
      searchResults: [],
      Types: [],
      //表格数据
      tableData: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }
    }
  },
  methods: {
    //条件查询
    searchlistdata (){
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset (){
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val
      this.pageConfig.pageNo = 1
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas () {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      let params = JSON.stringify(this.searchlist)
      console.log(params)
      var res = await request({
        url: "/documentHandling/info/listDocumentHandling",
        method: "POST",
        headers:{
          'Content-Type':'application/json;charset=UTF-8'
        },
        data: params
      })
      // console.log(res)
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list
      }else{
        console.log(res)
        this.$message({
          message: "数据加载异常",
          type: "error"
        });
      }
    },
    //获取统计数据
    async getStatistics() {
      let fd = new FormData()
      fd.append("token", token)
      var res = await request({
        url: "/documentHandling/info/documentHandlingStatistics",
        method: "POST",
        data: fd
      })
      // console.log(res)
      if (res.code == 200) {
        this.showDatas = {wait: res.content[0].jrsb, 
          undo: res.content[0].wcl, error: res.content[0].blyc, end: res.content[0].ycl}
      }else{
        console.log(res)
        this.$message({
          message: "获取统计信息异常",
          type: "error"
        });
      }
    },
    //导出excel
    async createExcel() {
      let fd = new FormData()
      fd.append("token", token)
      this.$delete(this.searchlist,'pageSize')
      this.$delete(this.searchlist,'pageNo')
      let params = JSON.stringify(this.searchlist);
      fd.append("findDocumentHandling", params)
      var res = await request({
        url: "/documentHandling/info/downloadExcel",
        method: "GET",
        data: fd
      })
      if (res.code == 200) {
        this.$message({
          message: "导出成功",
          type: "error"
        });
      }else{
        console.log(res)
        this.$message({
          message: "导出异常",
          type: "error"
        });
      }
    },
    receiveChange(selVal) {
      if(selVal == '0'){
        this.showReceiveStatusYes = true
        this.showReceiveStatusNo = false
      }else if(selVal == '1'){
        this.showReceiveStatusNo = true
        this.showReceiveStatusYes = false
      }
    },
    async showDialogForm(id,flag) {
      this.showadd=true
      this.flag = flag
      if(id != ''){
        if(flag == 'do'){
          this.dialogTitle = '处理'
          this.showReceiveStatus = true
          this.receiveDisable = false
          this.showStatus = false
          this.statusDisable = true
          this.showSaveBtn = true
        }else if(flag == 'detail'){
          this.dialogTitle = '查看'
          this.showSaveBtn = false
          this.showReceiveStatus = true
          this.receiveDisable = true
          this.showStatus = true
          this.statusDisable = true
        }else if(flag == 'result'){
          this.dialogTitle = '办理'
          this.showSaveBtn = true
          this.showReceiveStatus = true
          this.receiveDisable = true
          this.showStatus = true
          this.statusDisable = false
        }
        //获取编辑项的最新数据
        let fd = new FormData()
        fd.append("token", token)
        fd.append("id", id)
        var res = await request({
          url: "/documentHandling/info/getDocumentHandling",
          method: "POST",
          data: fd
        })
        console.log(res)
        if (res.code == 200) {
          this.addform = res.content
          if(this.addform.handleState == '0'){
            this.showReceiveStatusYes = true
            this.showReceiveStatusNo = false
          }else if(this.addform.handleState == '1'){
            this.showReceiveStatusNo = true
            this.showReceiveStatusYes = false
          }
          if(this.addform.template){
            var enclosureMap = {
              marital: {index:1, name:'婚育证明', img:require("../../../assets/images/oneStopProcessing/4.jpg")},
              baby: {index:1, name:'出生证明', img:require("../../../assets/images/oneStopProcessing/4.jpg")},
              commitment: {index:1, name:'承诺书', img:require("../../../assets/images/oneStopProcessing/1.jpg")},
              others: {index:1, name:'其它附件', img:require("../../../assets/images/oneStopProcessing/1.jpg")},
            }
            if(this.addform.marital){
              enclosureMap.marital.img = this.addform.marital
            }
            if(this.addform.baby){
              enclosureMap.baby.img = this.addform.baby
            }
            if(this.addform.commitment){
              enclosureMap.commitment.img = this.addform.commitment
            }
            if(this.addform.others){
              enclosureMap.others.img = this.addform.others
            }
            //对附件上传信息进行拆分
            var enclosureArr = this.addform.template.enclosure.split(',')
            var index = 0
            var temp = {}
            this.enclosure1 = []
            this.enclosure2 = []
            enclosureArr.forEach(item => {
              if(item != ''){
                index++
                temp = item=='marital'?enclosureMap.marital:(item=='baby'?enclosureMap.baby:(item=='commitment'?enclosureMap.commitment:enclosureMap.others))
                if(this.enclosure1.length < 2){
                  temp.index = this.enclosure1.length + 1
                  this.enclosure1.push(temp)
                }
                if(index > 2 && this.enclosure2.length < 2){
                  temp.index = this.enclosure2.length + 1
                  this.enclosure2.push(temp)
                }
              }
            });
          }else{
            this.addform.template = {
              basicOptions: '',
              fixedOption: '',
              enclosure: ''
            }
          }
        }else{
          console.log(res.code + '：' +res.message)
          this.$message({
            message: "数据加载异常",
            type: "error"
          })
          this.showadd = false
        }
      }else{
        this.showadd = false
        this.$message({
            message: "id不可为空",
            type: "error"
          })
      }
      
    },
    //获取新增所有数据发请求
    async saveadddata() {
      this.$message({
        message: "接口尚未出，请等待",
        type: "error"
      });
      return

      let fd = new FormData()
      fd.append("token", token)
      let params = {}
      let url = "/documentHandling/info/updatedDocumentHandling"
      if(this.flag == 'do'){
        params = {
          id: this.addform.id,
          handleState: this.handleState,
          processingRemarks: this.processingRemarks,
          requiredTime: this.requiredTime,
          reason: this.reason,
          reasonExplain: this.reasonExplain 
        }
        url = "/documentHandling/info/manageDocumentHandling"
        fd.append("manageDocumentHandling", JSON.stringify(params))
      }else if(this.flag == 'result'){
        params = {
          id: this.addform.id,
          handlingStatus: this.handlingStatus
        }
        url = "/documentHandling/info/handleDocumentHandling"
        fd.append("handleDocumentHandling", JSON.stringify(params))
      }
      
      console.log(params)

      var res = await request({
        url: url,
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + '成功',
          type: "success"
        });
        this.showadd = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      }else{
        console.log(res)
        this.$message({
            message: this.dialogTitle + "失败：" + res.message,
            type: "error"
          });
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false
    },
    // 图表加载函数
    drawChart() {
      //折线图
      let myChart_l_1 = this.$echarts.init(document.getElementById("chart_1_1"));
      var option_1_1 = echarts_msg.option_line
      option_1_1.legend.data = ['申办数', '已完成', '办理中', '办理异常']
      option_1_1.xAxis.type = 'category'
      option_1_1.xAxis.data = ['1月', '2月','3月', '4月','5月', '6月','7月', '8月', '9月','10月','11月', '12月']
      option_1_1.yAxis.type = 'value'
      option_1_1.series = [
        {name: '申办数', type: 'line', data: [12, 13, 10, 13, 9, 23, 21,12,23,34,32,12]},
        {name: '已完成', type: 'line', data: [22, 18, 19, 34, 29, 30, 30,15,2,34,32,121]},
        {name: '办理中', type: 'line', data: [15, 22, 21, 54, 90, 30, 41,12,27,41,32,10]},
        {name: '办理异常', type: 'line', data: [32, 32, 31, 34, 39, 33, 32,19,23,2,3,2]}
      ]
      myChart_l_1.setOption(option_1_1);
      let sizeFun = function() {
        myChart_l_1.resize();
      };
      window.addEventListener("resize", sizeFun);
    },
    //获取条件查询的一级分类
    async getSelects() {
      //默认写死
      this.searchStatus = [{value: '0', label: '未处理' }, 
                      { value: '1', label: '接收' }, 
                      { value: '2', label: '不接收' }]
      this.searchResults = [{value: '0', label: '办理中' }, 
                      { value: '1', label: '待领证' }, 
                      { value: '2', label: '办理异常' },
                      { value: '3', label: '已结束' }]
      this.Types = [{label:'民政服务',value:'民政服务'},{label:'其它',value:'其它'}]
      this.IDTypes = [
        {label:'身份证号',value:'身份证号'},
        {label:'军官证号',value:'军官证号'},
        {label:'驾驶证号',value:'驾驶证号'},
        {label:'外国人居留证',value:'外国人居留证'}
      ]
    },
  },
  mounted() {
    //数据赋值
    this.getStatistics()
    // 初始化图表加载
    this.drawChart();
    this.getSelects()
    this.getPageDatas()
  }
};
</script>

<style lang="less" scoped>
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    width: 270px;
  }
  .card-r {
    flex: 1;
    height: 320px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-0 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        .child-item {
          float: left;
          width: 40%;
          margin-left: 7%;
          margin-top: 20px;
          padding: 10px 0;
          line-height: 40px;
          box-sizing: border-box;
					border: 1px solid #dcdcdc;
					border-radius: 5px;
					background:linear-gradient(to bottom, #fff, #f2f2f2);
					display: flex;
					flex-direction: column;
					align-content: center;
					justify-content: space-between;
					text-align: center;
          flex-wrap: wrap;
          
          div {
            width: 100%;
            text-align: center;
          }
          div:first-child {
            font-size: 24px;
            color: red;
          }
          div:last-child {
            font-size: 14px;
          }
        }
      }
    }
    .card-2 {
      width: 65%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .topbarnav {
      display: flex;
      align-items: center;
      div {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
      }
    }
  }
}
.card-4 {
  margin-top: 12px;
}
// 表格的盒子
.table_card {
  /**解决表格无法自适应宽度 */
  /*width: calc(100vw - 500px); */
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
.tempItem {
  border: #cfd8e1 1px solid;
  box-sizing: border-box;
  width: 100%;
  height: 450px;
  // background-color: red;
  display: flex;
  // justify-content: center;
  align-items: center;
  .leftstyle {
    width: 40px;
    height: 100%;
    background-color: #01aaef;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 20px;
      text-align: center;
      font-size: 18px;
      color: #fff;
    }
  }
}
.rdxxright {
  width: calc(100% - 40px);
  height: 100%;
  background-color: #f8faf9;
  .rdxxflextop {
    width: 100%;
    height: 75%;
    display: flex;
    margin-top: 10px;
    .rdxxflex1 {
      flex: 1.5;
      box-sizing: border-box;
      padding-left: 20px;
      .imgDiv{
        width: 270px;
        height: 166px;
        border-radius: 5px;
        margin-left: 90px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .rdxxflex2 {
      flex: 1.5;
      box-sizing: border-box;
      padding-left: 40px;
      .imgDiv{
        width: 270px;
        height: 166px;
        border-radius: 5px;
        margin-left: 10px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .rdxxflexbootm {
    width: 100%;
    height: 25%;
  }
}
</style>